<!-- <div class="container">
  <div coass="row">
    <div class="col">
      <div class="card" *ngIf="showCategory">
        <div class="card-body">
          <h4 class="card-title">Category: {{categoryName}}</h4>
          <div class="instructions">
            <p>Enter the information below to edit the category on the <em><u>Category Detail</u></em> tab.  On the <em><u>Subcategories</u></em> tab, you will maintain Subcategories
              for this parent category.</p>
          </div>
          <mat-tab-group>
            <mat-tab label="Category Detail">
              <div class="category-content">
                <form [formGroup]="parentForm">
                    <div class="d-flex">
                      <div class="p-2 w-50">
                        <img src="{{ imageSource }}/{{imagePath }}" alt="Product Image" /><br/><br/>
                        <div class="upload-data">
                          <input type="file" formControlName="imagePath" (change)="onFileChange($event.target.files)" />
                        </div>
                      </div>
                      <div class="flex-column w-50">
                        <div class="p-2">
                          <div class="form-group">
                            <label>Category Name:</label>
                            <input type="text" class="form-control" formControlName="name" placeholder="Enter category name" />
                          </div>
                        </div>
                        
                        <div class="p-2">
                          <div class="form-group form-check">
                            <input type="checkbox" class="form-check-input" formControlName="activeFlag" />
                            <label class="form-check-label">&nbsp;Is Active Category</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="text-right">
                      <button class="btn btn-primary" type="submit" (click)="submit()"><i class="fa fa-check"></i>&nbsp;Save</button>
                    </div>
                  
                </form>
              </div>
            </mat-tab>
            <mat-tab label="Subcategories">
              <div class="row">
                <div class="col">
                  <div class="subcat-content">
                    <fieldset>
                      <legend>Subcategories</legend>
                      <div *ngFor="let c of parentCategory.children">
                        <div class="card">
                          <div class="card-body">
                            <div class="row">
                              <div *ngIf="!c.isEditMode" style="width: 100%">
                                <div class="col-sm">{{ c.name }}</div>
                                <div class="col-sm text-right">
                                  <button class="btn btn-primary" (click)="toggleEdit(c)"><i class="fa fa-pencil"></i>&nbsp;Edit</button>
                                </div>
                              </div>
                              <div *ngIf="c.isEditMode" style="width: 100%">
                                <div class="col-sm">
                                  <div class="row mb-2">
                                    <form class="form-inline" [formGroup]="categoryForm">
                                      <div class="col-sm">
                                        <div class="form-group mb-2">
                                          <label>Subcategory Name</label>
                                          <input type="text" class="form-control" formControlName="name" placeholder="Enter subcategory name" />
                                        </div>
                                      </div>
                                      <div class="col-sm">
                                        <div class="form-group form-check mb-2">
                                          <input type="checkbox" class="form-check-input" formControlName="activeFlag" />
                                          <label class="form-check-label">&nbsp;Is Active Category</label>
                                        </div>
                                      </div>
                                      <div class="col-sm">
                                        <div class="text-right mb-2">
                                          <button class="btn btn-default" (click)="toggleEdit(c)"><i class="fa fa-remove"></i>&nbsp;Cancel</button>
                                          <button class="btn btn-success" type="button" (click)="updateCategory()"><i class="fa fa-check"></i>&nbsp;Update</button>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <table class="table">
                        <tbody>
                          <tr>
                            <td>
                              <input type="text" class="form-control" [(ngModel)]="newCategory.name" placeholder="Enter subcategory name" />
                            </td>
                            <td>
                              <button class="btn btn-success" type="button" (click)="saveNewCategory()"><i class="fa fa-plus"></i>&nbsp;Add</button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </fieldset>
                  </div>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
          
        </div>
      </div>
    </div> 
  </div>
</div> -->

<div class="container py-4">
  <!-- Page Header -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="d-flex align-items-center mb-3">
        <button 
          class="btn btn-outline-secondary me-3"
          (click)="onCancel()"
          type="button">
          <i class="fa fa-arrow-left me-2"></i>Back to Categories
        </button>
        <div>
          <h2 class="fw-bold text-dark mb-1">
            {{ isEditMode ? 'Edit Category' : 'Add New Category' }}
          </h2>
          <p class="text-muted mb-0">
            {{ isEditMode ? 'Update category information and manage subcategories' : 'Create a new product category' }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="row">
    <div class="col-12">
      <div class="d-flex justify-content-center align-items-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <span class="ms-3 text-muted">Loading category...</span>
      </div>
    </div>
  </div>

  <!-- Success Message -->
  <div *ngIf="success" class="row mb-4">
    <div class="col-12">
      <div class="alert alert-success d-flex align-items-center" role="alert">
        <i class="fa fa-check-circle me-3"></i>
        <div>{{ success }}</div>
      </div>
    </div>
  </div>

  <!-- Error Message -->
  <div *ngIf="error" class="row mb-4">
    <div class="col-12">
      <div class="alert alert-danger d-flex align-items-center" role="alert">
        <i class="fa fa-exclamation-triangle me-3"></i>
        <div>{{ error }}</div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div *ngIf="!isLoading" class="row">
    <div class="col-lg-8">
      <!-- Category Form -->
      <div class="card shadow-sm border-0 mb-4">
        <div class="card-header bg-white border-bottom-0 py-3">
          <h5 class="card-title mb-0 fw-bold">Category Information</h5>
        </div>
        <div class="card-body">
          <form [formGroup]="categoryForm" (ngSubmit)="onSubmit()">
            <!-- Category Name -->
            <div class="row mb-3">
              <div class="col-md-6">
                <label for="name" class="form-label fw-medium">
                  Category Name <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  formControlName="name"
                  [class.is-invalid]="isFieldInvalid('name')"
                  placeholder="Enter category name">
                <div class="invalid-feedback">
                  {{ getFieldError('name') }}
                </div>
              </div>
              <div class="col-md-6">
                <label for="slug" class="form-label fw-medium">
                  URL Slug <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="slug"
                  formControlName="slug"
                  [class.is-invalid]="isFieldInvalid('slug')"
                  placeholder="category-url-slug">
                <div class="invalid-feedback">
                  {{ getFieldError('slug') }}
                </div>
                <small class="form-text text-muted">Only lowercase letters, numbers, and hyphens allowed</small>
              </div>
            </div>

            <!-- Description -->
            <!-- <div class="mb-3">
              <label for="description" class="form-label fw-medium">Description</label>
              <textarea
                class="form-control"
                id="description"
                rows="4"
                formControlName="description"
                [class.is-invalid]="isFieldInvalid('description')"
                placeholder="Enter category description..."></textarea>
              <div class="invalid-feedback">
                {{ getFieldError('description') }}
              </div>
            </div> -->

            <!-- Sort Order and Status -->
            <div class="row mb-3">
              <div class="col-md-6">
                <label for="sortOrder" class="form-label fw-medium">Sort Order</label>
                <input
                  type="number"
                  class="form-control"
                  id="sortOrder"
                  formControlName="sortOrder"
                  [class.is-invalid]="isFieldInvalid('sortOrder')"
                  min="0"
                  placeholder="0">
                <div class="invalid-feedback">
                  {{ getFieldError('sortOrder') }}
                </div>
              </div>
              <div class="col-md-6 d-flex align-items-end">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="activeFlag"
                    formControlName="activeFlag">
                  <label class="form-check-label fw-medium" for="activeFlag">
                    Active Category
                  </label>
                </div>
              </div>
            </div>

            <!-- SEO Section -->
            <div class="border-top pt-3">
              <h6 class="fw-bold mb-3">SEO Settings</h6>
              
              <!-- <div class="row mb-3">
                <div class="col-md-6">
                  <label for="metaTitle" class="form-label fw-medium">Meta Title</label>
                  <input
                    type="text"
                    class="form-control"
                    id="metaTitle"
                    formControlName="metaTitle"
                    [class.is-invalid]="isFieldInvalid('metaTitle')"
                    placeholder="SEO title for search engines">
                  <div class="invalid-feedback">
                    {{ getFieldError('metaTitle') }}
                  </div>
                </div>
              </div> -->

              <!-- <div class="mb-3">
                <label for="metaDescription" class="form-label fw-medium">Meta Description</label>
                <textarea
                  class="form-control"
                  id="metaDescription"
                  rows="3"
                  formControlName="metaDescription"
                  [class.is-invalid]="isFieldInvalid('metaDescription')"
                  placeholder="SEO description for search engines (max 160 characters)"></textarea>
                <div class="invalid-feedback">
                  {{ getFieldError('metaDescription') }}
                </div>
              </div> -->
            </div>
          </form>
        </div>
      </div>

      <!-- Subcategories Section (Only in Edit Mode) -->
      <div *ngIf="isEditMode" class="card shadow-sm border-0">
        <div class="card-header bg-white border-bottom-0 py-3">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0 fw-bold">Subcategories</h5>
            <button 
              class="btn btn-primary btn-sm"
              (click)="onAddSubcategory()"
              type="button">
              <i class="fa fa-plus me-1"></i>Add Subcategory
            </button>
          </div>
        </div>
        
        <div class="card-body">
          <div *ngIf="subcategories.length === 0" class="text-center py-4">
            <i class="fa fa-folder-open text-muted mb-3" style="font-size: 2rem;"></i>
            <p class="text-muted mb-3">No subcategories found</p>
            <button 
              class="btn btn-outline-primary"
              (click)="onAddSubcategory()"
              type="button">
              <i class="fa fa-plus me-2"></i>Add First Subcategory
            </button>
          </div>

          <!-- Subcategories Table -->
          <div *ngIf="subcategories.length > 0" class="table-responsive">
            <table class="table table-hover align-middle">
              <thead class="table-light">
                <tr>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Sort Order</th>
                  <th>Created</th>
                  <th width="150">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let subcategory of subcategories">
                  <td>
                    <div class="fw-medium text-dark">{{ subcategory.name }}</div>
                    <small class="text-muted" *ngIf="subcategory.description">{{ subcategory.description }}</small>
                    <!-- <div *ngIf="subcategory.slug" class="mt-1">
                      <small class="text-muted">
                        <i class="fa fa-link me-1"></i>{{ subcategory.slug }}
                      </small>
                    </div> -->
                  </td>
                  <td>
                    <span 
                      class="badge"
                      [class]="subcategory.activeFlag ? 'bg-success' : 'bg-secondary'">
                      {{ subcategory.activeFlag ? 'Active' : 'Inactive' }}
                    </span>
                  </td>
                  <td>
                    <span class="fw-medium">{{ subcategory.sortOrder }}</span>
                  </td>
                  <td>
                    <small class="text-muted" *ngIf="subcategory.createdDate">
                      {{ subcategory.createdDate | date:'MMM dd, yyyy' }}
                    </small>
                  </td>
                  <td>
                    <div class="btn-group btn-group-sm" role="group">
                      <button 
                        class="btn btn-outline-primary"
                        (click)="onEditSubcategory(subcategory)"
                        title="Edit Subcategory"
                        type="button">
                        <i class="fa fa-edit"></i>
                      </button>
                      <button 
                        class="btn"
                        [class]="subcategory.activeFlag ? 'btn-outline-warning' : 'btn-outline-success'"
                        (click)="onToggleSubcategoryStatus(subcategory)"
                        [title]="subcategory.activeFlag ? 'Deactivate' : 'Activate'"
                        type="button">
                        <i class="fa" [class]="subcategory.activeFlag ? 'fa-pause' : 'fa-play'"></i>
                      </button>
                      <button 
                        class="btn btn-outline-danger"
                        (click)="onDeleteSubcategory(subcategory)"
                        title="Delete Subcategory"
                        type="button">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>

    <!-- Sidebar -->
    <div class="col-lg-4">
      <!-- Image Upload -->
      <div class="card shadow-sm border-0 mb-4">
        <div class="card-header bg-white border-bottom-0 py-3">
          <h5 class="card-title mb-0 fw-bold">Category Image</h5>
        </div>
        <div class="card-body">
          <!-- Image Preview -->
          <div class="text-center mb-3">
            <div *ngIf="imagePreview" class="position-relative d-inline-block">
              <img 
                [src]="imagePreview" 
                alt="Category preview" 
                class="img-fluid rounded"
                style="max-width: 200px; max-height: 200px; object-fit: cover;">
              <button 
                class="btn btn-sm btn-danger position-absolute top-0 end-0 m-2"
                (click)="onRemoveImage()"
                type="button"
                title="Remove Image">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <div *ngIf="!imagePreview" class="border rounded p-4 bg-light">
              <i class="fa fa-image text-muted mb-2" style="font-size: 2rem;"></i>
              <p class="text-muted mb-0">No image selected</p>
            </div>
          </div>

          <!-- File Input -->
          <input 
            type="file" 
            class="form-control" 
            id="imageInput"
            accept="image/*"
            (change)="onImageChange($event)">
          <small class="form-text text-muted mt-2">
            Supported formats: JPG, PNG, GIF. Max size: 5MB
          </small>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <div class="d-grid gap-2">
            <button 
              type="button"
              class="btn btn-primary btn-lg"
              [disabled]="isSaving || categoryForm.invalid"
              (click)="onSubmit()">
              <span *ngIf="!isSaving">
                <i class="fa fa-save me-2"></i>
                {{ isEditMode ? 'Update Category' : 'Create Category' }}
              </span>
              <span *ngIf="isSaving">
                <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                {{ isEditMode ? 'Updating...' : 'Creating...' }}
              </span>
            </button>
            
            <button 
              type="button"
              class="btn btn-outline-secondary"
              (click)="onCancel()"
              [disabled]="isSaving">
              <i class="fa fa-times me-2"></i>Cancel
            </button>
          </div>

          <!-- Form Status -->
          <div class="mt-3 pt-3 border-top">
            <small class="text-muted">
              <div class="d-flex justify-content-between">
                <span>Form Status:</span>
                <span [class]="categoryForm.valid ? 'text-success' : 'text-danger'">
                  {{ categoryForm.valid ? 'Valid' : 'Invalid' }}
                </span>
              </div>
              <div *ngIf="isEditMode && category" class="mt-2">
                <div class="d-flex justify-content-between">
                  <span>Created:</span>
                  <span>{{ category.createdDate | date:'MMM dd, yyyy' }}</span>
                </div>
                <div *ngIf="category.updatedDate" class="d-flex justify-content-between">
                  <span>Last Updated:</span>
                  <span>{{ category.updatedDate | date:'MMM dd, yyyy' }}</span>
                </div>
              </div>
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>

<!-- Subcategory Modal -->
<app-admin-subcategory-modal
  [subcategory]="editingSubcategory"
  [categoryId]="categoryId!"
  [isVisible]="showSubcategoryModal"
  [existingSubcategories]="subcategories"
  [isEditMode]="isEditingSubcategory"
  (save)="onSaveSubcategory($event)"
  (close)="onCloseSubcategoryModal()"
  (delete)="onDeleteSubcategory($event)"
  (toggleStatus)="onToggleSubcategoryStatus($event)">
</app-admin-subcategory-modal>